import DOMPurify from 'dompurify'

/**
 * Allowed tags and attributes for Paddle product delivery instructions.
 * @see https://classic.paddle.com/reference/platform-parameters/supported-html-tags/
 */
const ALLOWED_TAGS = [
  'a',
  'abbr',
  'acronym',
  'address',
  'area',
  'b',
  'bdo',
  'big',
  'blockquote',
  'br',
  'caption',
  'center',
  'cite',
  'code',
  'col',
  'colgroup',
  'dd',
  'del',
  'dfn',
  'dir',
  'div',
  'dl',
  'dt',
  'em',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hr',
  'i',
  'img',
  'ins',
  'kbd',
  'li',
  'map',
  'ol',
  'p',
  'pre',
  'q',
  's',
  'small',
  'span',
  'strike',
  'strong',
  'sub',
  'sup',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'tr',
  'tt',
  'u',
  'ul',
  'var',
]

const ALLOWED_ATTR = [
  'align',
  'alt',
  'border',
  'cellpadding',
  'cellspacing',
  'colspan',
  'dir',
  'height',
  'href',
  'rowspan',
  'src',
  'style',
  'target',
  'title',
  'valign',
  'width',
]

export function sanitizeInstructions(dirty: string): string {
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank')
      node.setAttribute('rel', 'noopener noreferrer')
      node.setAttribute('referrerpolicy', 'no-referrer')
    }
  })

  const clean = DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ADD_ATTR: ['target', 'rel', 'referrerpolicy'],
    ALLOW_DATA_ATTR: false,
    ALLOWED_URI_REGEXP: /^https?:\/\//i,
  })

  DOMPurify.removeAllHooks()

  return clean
}
